'use strict';

// global vars
var currentSlide = 0;
var hide = 'd-none';
var visible = ':visible';

/**
 * switchView()
 * private function
 * allows to change view on the modal
 * @returns {void}
 */
function switchView (n) {
    var slides = $(SELECTORS.cards);
    if (n >= slides.length) {
        currentSlide = 0;
    }
    if (n < 0) {
        currentSlide = slides.length - 1;
    }
    slides.addClass(hide);
    slides.eq(currentSlide).removeClass(hide);
}

/**
 * checkAvailability()
 * private function
 * validate selected event type
 * @returns {void}
 */
function checkAvailability (params, url) {
    // check appt availability
    var svcResult = '';
    var svcMsg = '';
    $('.modal').spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        data: params,
        async: false,
        success: function (res) {
            $('.modal').spinner().stop();
            if (!res.success) {
                return {
                    'svcResult': '',
                    'svcMsg': ''
                };
            } else {
                let results = res.svcResponse.results[0];
                svcResult = results.Result;
                svcMsg = results.Message;
            }
        }
    });

    return {
        'svcResult': svcResult,
        'svcMsg': svcMsg
    };
}

/**
 * getCurrentSlide()
 * private function
 * get the current slide jquery dom.
 */
function getCurrentSlide() {
    return $(SELECTORS.cards).eq(currentSlide);
}

const SELECTORS = {
    appointmentEventSelector: '.js-event-appointment-type-select',
    appointmentReasonsTypeSelector: '.js-reason-type-select',
    appointmentContainerSelector: '.js-appointment-container',
    appointmentPartyTypeSelector: '.js-event-party-select',
    appointmentMemberNextBtnSelector: '.js-appt-member-next-btn',
    appointmentMemberPrevBtnSelector: '.js-appt-member-prev-btn',
    appointmentMemberSubmitBtnSelector: '.js-appt-member-submit-btn',
    appointmentModalSelect: '.modal select',
    caledarContainer: '.js-caledar-container',
    timeSlotsContainer: '.js-time-slots',
    cards: $('.js-cards'),
    form: '.js-create-event-form',
    appointmentPartySection: '.party-size-section',
    locationSelect: '.js-appointment-store-locations-select',
    body: 'body'
}

// open publicly for thirdy party calls
window.appointmentModal = function () {
    $('.js-invite-member-modal').modal();
}

// open publicly for third party calls (e.g., Fastr PLP snippets)
window.scheduleTypeModal = function () {
    // Close any currently open modal first
    if ($('.modal.show').length) {
        $('.modal.show').modal('hide');
    }
    $('.js-schedule-type-modal').modal();
}

/**
 * getInvalidMsgEl()
 * Returns the .js-invalid-message element for a given input.
 * @param {jQuery} $input
 * @returns {jQuery}
 */
function getInvalidMsgEl($input) {
    return $input.closest('.f-field-wrapper').find('.js-invalid-message');
}

/**
 * hasCharErrors()
 * Returns true if any of the four validated fields currently contain
 * characters that fail their respective allowed-char rules.
 * @returns {boolean}
 */
function hasCharErrors() {
    var error = false;

    // Name fields: letters, digits, space, hyphen, period
    $('.js-validate-name').each(function () {
        if (/[^a-zA-Z0-9 .-]/.test($(this).val())) {
            error = true;
        }
    });

    // Email field: letters, digits, @, hyphen, underscore, period — or invalid format
    var $email = $('.js-validate-email');
    if ($email.length) {
        var emailVal = $email.val();
        if (/[^a-zA-Z0-9@._-]/.test(emailVal) || (emailVal && !$email[0].validity.valid)) {
            error = true;
        }
    }

    // Phone field: digits and hyphen
    if (/[^0-9-]/.test($('.js-validate-phone').val())) {
        error = true;
    }

    return error;
}

/**
 * updateSubmitBtnState()
 * Disables the Submit button when any char-validation error exists;
 * re-enables it once all errors are cleared.
 * @returns {void}
 */
function updateSubmitBtnState() {
    $(SELECTORS.appointmentMemberSubmitBtnSelector).prop('disabled', hasCharErrors());
}

/**
 * handleNameInput()
 * Validates name fields: allows a-z A-Z 0-9 space hyphen period only.
 * Shows/clears error in .js-invalid-message (same element as existing validation).
 * @param {Event} e
 * @returns {void}
 */
function handleNameInput(e) {
    var $input = $(e.currentTarget);
    var val = $input.val();
    // Allow: letters (a-z, A-Z), digits (0-9), space, hyphen, period
    if (/[^a-zA-Z0-9 .-]/.test(val)) {
        getInvalidMsgEl($input).text('Invalid characters; please remove');
    } else {
        getInvalidMsgEl($input).empty();
    }
    updateSubmitBtnState();
}

/**
 * handleEmailInput()
 * Validates email field: allows a-z A-Z 0-9 @ hyphen underscore period only.
 * Shows/clears error in .js-invalid-message (same element as existing validation).
 * @param {Event} e
 * @returns {void}
 */
function handleEmailInput(e) {
    var $input = $(e.currentTarget);
    var val = $input.val();
    // Allow: letters (a-z, A-Z), digits (0-9), @, hyphen, underscore, period
    if (/[^a-zA-Z0-9@._-]/.test(val)) {
        getInvalidMsgEl($input).text('Invalid email');
    } else {
        getInvalidMsgEl($input).empty();
    }
    updateSubmitBtnState();
}

/**
 * handlePhoneInput()
 * Validates phone field: allows 0-9 and hyphen only.
 * Shows/clears error in .js-invalid-message (same element as existing validation).
 * @param {Event} e
 * @returns {void}
 */
function handlePhoneInput(e) {
    var $input = $(e.currentTarget);
    var val = $input.val();
    // Allow: digits (0-9) and hyphen
    if (/[^0-9-]/.test(val)) {
        getInvalidMsgEl($input).text('Invalid phone number. Format should be 555-555-5555.');
    } else {
        getInvalidMsgEl($input).empty();
    }
    updateSubmitBtnState();
}

/**
 * handleCharFocusOut()
 * Re-applies the char-validation error for name and email fields after the
 * existing clientSideValidation focusout handler has run (which calls
 * validateElement() and empties .js-invalid-message when checkValidity()
 * @param {Event} e
 * @returns {void}
 */
function handleCharFocusOut(e) {
    var $input = $(e.currentTarget);
    setTimeout(function () {
        var val = $input.val();
        var msg = '';
        if ($input.hasClass('js-validate-name') && /[^a-zA-Z0-9 .-]/.test(val)) {
            msg = 'Invalid characters; please remove';
        } else if ($input.hasClass('js-validate-email')) {
            // Cover both cases: forbidden chars, and valid chars but bad format.
            if (val && (/[^a-zA-Z0-9@._-]/.test(val) || !$input[0].validity.valid)) {
                msg = 'Invalid email';
            }
        }
        if (msg) {
            getInvalidMsgEl($input).text(msg);
        }
        updateSubmitBtnState();
    }, 0);
}

/**
 * Init appointment modal listener
 * @returns {void}
 */
function init() {
    $(SELECTORS.appointmentEventSelector).on('change click', handleAppointmentEventSelection);
    $(SELECTORS.appointmentReasonsTypeSelector).on('change click', handleAppointmentReasonSelection);
    $(SELECTORS.appointmentContainerSelector).on('shown.bs.modal', handleBSModalShown);
    $(SELECTORS.appointmentContainerSelector).on('hidden.bs.modal', handleBSModalHidden);
    $(SELECTORS.appointmentPartyTypeSelector).on('change click', handleAppointmentPartySelection);
    $(SELECTORS.appointmentMemberNextBtnSelector).on('click', handleNextBtn);
    $(SELECTORS.appointmentMemberPrevBtnSelector).on('click', handlePrevBtn);
    $(SELECTORS.appointmentModalSelect).on('change click', handleModalSelect);
    $(SELECTORS.form).on('submit', handleFormSubmit);
    $(document).on('input', '.js-validate-name', handleNameInput);
    $(document).on('input', '.js-validate-email', handleEmailInput);
    $(document).on('input', '.js-validate-phone', handlePhoneInput);
    $(document).on('focusout', '.js-validate-name, .js-validate-email', handleCharFocusOut);
}

/**
 * change select
 */
const handleModalSelect = () => {
    //let $this = $(e.currentTarget);
    //$($this).find(':selected').trigger('click');
    $('.modal button').attr('disable', false);
}

/**
 * next button event handler
 */
const handleNextBtn = () => {
    if (!$(SELECTORS.appointmentEventSelector).val()) {
        $(SELECTORS.appointmentEventSelector).parent().siblings('.js-invalid-message').text('Please select event type.')
        return;
    } else {
        $(SELECTORS.appointmentEventSelector).parent().siblings('.js-invalid-message').text('')
    }

    if (!$(SELECTORS.appointmentReasonsTypeSelector).val()) {
        $(SELECTORS.appointmentReasonsTypeSelector).parent().siblings('.js-invalid-message').text('Please select reason for visit.')
        return
    } else {
        $(SELECTORS.appointmentReasonsTypeSelector).parent().siblings('.js-invalid-message').text('')
    }

    // Party Size is mandatory
    if (!$('.party-size-section').hasClass(hide) && !$('#party-size').val()) {
        $('.party-size-section .js-invalid-message').text('Please select Party Size');
        return;
    }
    currentSlide++;

    // Refresh the calendar.
    if (!$(SELECTORS.cards).eq(0).hasClass(hide)) {
        $(SELECTORS.body).trigger('appointment:refreshAvailableDates');
    }

    $(SELECTORS.appointmentMemberPrevBtnSelector).removeClass(hide);
    $('.js-cancel-btn').hide();
    switchView(currentSlide);
    if ($('#firstName').is(visible)) {
        $(SELECTORS.appointmentMemberNextBtnSelector).addClass(hide);
        $(SELECTORS.appointmentMemberSubmitBtnSelector).removeClass(hide);
    }

    let $currentSlide = getCurrentSlide()
    if ($currentSlide.hasClass('appointment-calendar')) {
        $(SELECTORS.appointmentMemberNextBtnSelector).attr('disabled', true);
        // Trigger onSelect on the already selected date. So that it updates the availability and dates according to the currently selected Store
        $('.js-caledar-container .ui-state-active').trigger('click')
    }
    $(SELECTORS.appointmentMemberNextBtnSelector).addClass(hide);
}

/**
 * prev button event handler
 */
const handlePrevBtn = () => {
    let $currentSlide = getCurrentSlide()
    if ($currentSlide.hasClass('appointment-calendar')) {
        $(SELECTORS.caledarContainer).show();
        $(SELECTORS.timeSlotsContainer).hide();
    }

    currentSlide--;
    switchView(currentSlide);
    if ($('.js-appointment-store-locations-select').is(visible)) {
        $('.js-cancel-btn').show();
        $(SELECTORS.appointmentMemberPrevBtnSelector).addClass(hide);
    }

    $(SELECTORS.appointmentMemberSubmitBtnSelector).addClass(hide);
    $(SELECTORS.appointmentMemberNextBtnSelector)
        .removeClass(hide)
        .attr('disabled', false);

    if ($('.js-booking-container').is(visible)) {
        $(SELECTORS.appointmentMemberNextBtnSelector).addClass(hide);
    }
}

/**
 * handles form submit
 * @param {*} e
 * @returns {void}
 */
const handleFormSubmit = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    //collect form values
    let form = $($this).serialize();
    let url = $($this).attr('action');

    $('.modal').spinner().start();
    $(SELECTORS.form).addClass(hide)
    $.ajax({
        url: url,
        type: 'post',
        data: form,
        async: false,
        success: function (res) {
            if ('error' in res.svcResponse && res.svcResponse.error) {
                $('.js-apptform-result').append(res.svcResponse.errorMessage).removeClass(hide);
            } else {
                let result = res.svcResponse.results[0];
                if (!!result && result.Result === 'Success') {
                    $('.js-apptform-result').append(result.ConfirmHTML).removeClass(hide);
                }
            }
        },
        error: function (xhr) {
            // Handle any errors that occurred during the request
            $('.js-apptform-result').append(xhr.responseText).removeClass(hide);
        }
    });
    $('.modal').spinner().stop();

    return false;
}

// handles modal when displayed
const handleBSModalShown = (e) => {
    var triggerElement = e.relatedTarget;
    if (triggerElement) {
        var storeId = triggerElement.dataset.storeid;
        if (storeId) {
            // Auto-select the Store upon the customer’s clicking on the Schedule Appointment button on the desired store
            $("#event-location").val(storeId).trigger('change');
        }
    }
    $(SELECTORS.appointmentContainerSelector).removeClass(hide);

    // Pre-populate the form.
    var $form = $(SELECTORS.form);
    var params = $form.data('new-event-params');
    if (params && typeof params === 'object') {
        $form.find(SELECTORS.locationSelect).val(params.homeStore);
        $(SELECTORS.locationSelect).trigger('change');
        $form.find(SELECTORS.appointmentEventSelector).val(params.eventType);
        $(SELECTORS.appointmentEventSelector).trigger('change');
        $form.find('#firstName').val(decodeURIComponent(params.primaryContactFirst));
        $form.find('#lastName').val(decodeURIComponent(params.primaryContactLast));
        $form.find('#appointment-email').val(decodeURIComponent(params.primaryContactEmail));
        $form.find('#mobile').val(decodeURIComponent(params.primaryContactPhone));
        $form.find('#eventRole').val(decodeURIComponent(params.primaryContactRole));
        $form.find('#appointmentEventDate').val(decodeURIComponent(params.eventDate));
    }
}

// handles modal when hidden
const handleBSModalHidden = () => {
    $(SELECTORS.appointmentContainerSelector).addClass(hide);
}

/**
 * handleAppointmentEventSelection
 * dynamically populate list based selected value
 * @returns {void}
 */
const handleAppointmentEventSelection = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    let selected = $($this).find(':selected').val();
    let reasonsType = $('.js-reasonsType').data('reasontype');
    let selectedReasons = reasonsType[selected];
    let url = $('.js-checkAppointmentURL').data('checkappointmenturl');
    let params = {};
    let storeNo = $('.js-appointment-store-locations-select').find(':selected').val();
        storeNo = storeNo.replaceAll('ft-store','');

    params.apptType = selected;
    params.storeNo = storeNo;

    if (!$this.val()) {
        $(SELECTORS.appointmentReasonsTypeSelector).val('');
        $(SELECTORS.appointmentPartyTypeSelector).val('');
        $('.reasons-type-section, .party-size-section, .js-prom-selected').addClass(hide);
        return false;
    }

    let ajaxRes = checkAvailability(params, url);

    if (ajaxRes.svcResult !== 'Success') {
        $('.reasons-type-section, .party-size-section, .b-form-actions, .btn-cta').addClass(hide);
        $('.js-prom-selected').removeClass(hide).text(ajaxRes.svcMsg);
    } else {
        $('.b-form-actions, .reasons-type-section, .btn-cta').removeClass(hide);
        $('.js-prom-selected').addClass(hide);

        // reset
        $('.js-reason-type-select').find('.dynamic-reasons').remove();
        $('.js-event-party-select').find('.dynamic-event-party').remove();
        $(SELECTORS.appointmentPartySection).addClass(hide);
        $.each(selectedReasons, function (i, item) {
            $('.js-reason-type-select').append($('<option>', {
                value: item.value,
                text : item.text,
                class: 'dynamic-reasons'
            }));
        });
    }

    return false;
}

/**
 * handleAppointmentReasonSelection
 * dynamically populate list based selected value
 * @returns {void}
 */
const handleAppointmentReasonSelection = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    let selected = $($this).find(':selected').val();
    let eventParty = $('.js-eventParty').data('eventparty');
    let selectedEvent = eventParty[selected];
    let url = $('.js-checkAppointmentURL').data('checkappointmenturl');
    let params = {};
    let storeNo = $('.js-appointment-store-locations-select').find(':selected').val();

    params.apptType = selected;
    params.storeNo = storeNo;

    // check appt availability
    let ajaxRes = checkAvailability(params, url);
    if (ajaxRes.svcResult !== 'Success') {
        $(SELECTORS.appointmentMemberNextBtnSelector).prop('disabled', true);
        $(SELECTORS.appointmentPartySection).removeClass(hide);
        $(SELECTORS.appointmentPartySection + ' div.js-invalid-message').text(ajaxRes.svcMsg);
        $(SELECTORS.appointmentPartySection + ' p.f-field-group-label').addClass(hide);
        $(SELECTORS.appointmentPartySection + ' > .selection').addClass(hide);
        $(SELECTORS.appointmentPartySection).find('.f-form-select').addClass(hide);
    } else {
        $(SELECTORS.appointmentMemberNextBtnSelector).prop('disabled', false);
        $(SELECTORS.appointmentPartySection + ' div.js-invalid-message').text('');
        $(SELECTORS.appointmentPartySection).find('.f-form-select').removeClass(hide);

        // reset first
        $('.js-event-party-select').find('.dynamic-event-party').remove();
        $.each(selectedEvent, function (i, item) {
            $('.js-event-party-select').append($('<option>', {
                value: item.value,
                text : item.text,
                class : 'dynamic-event-party'
            }));
        });

        if (selectedEvent) {
            $(SELECTORS.appointmentPartySection).removeClass(hide);
        } else {
            $(SELECTORS.appointmentPartySection).addClass(hide);
        }
    }

    return false;
}

/**
 * handleAppointmentReasonSelection
 * dynamically populate list based selected value
 * @returns {void}
 */
const handleAppointmentPartySelection = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    let selected = $($this).find(':selected').val();
    let url = $('.js-checkAppointmentURL').data('checkappointmenturl');
    let params = {};
    let storeNo = $('.js-appointment-store-locations-select').find(':selected').val();

    params.apptType = selected;
    params.storeNo = storeNo;

    // check appt availability
    let ajaxRes = checkAvailability(params, url);

    if (ajaxRes.svcResult !== 'Success') {
        $('.js-appt-member-submit-btn').prop('disabled', true);
        $('.party-size-section').addClass(hide).text(ajaxRes.svcMsg);
    } else {
        $('.js-appt-member-submit-btn').prop('disabled', false);
    }
    return false;
}

module.exports = init();
